import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
  RefreshOnboardingLinkPayload,
  StartBankOnboardingPayload,
  StripeAchPayout,
  StripeConnectAccountStatus,
  StripeConnectOnboardingLink,
} from '@/models/stripeConnectModels';
import {
  getStripeConnectPayouts,
  getStripeConnectStatus,
  refreshOnboardingLink,
  startBankOnboarding,
} from '@/services/api/modules/stripeConnectApi';

const stripeConnectApi = createApi({
  reducerPath: 'stripeConnectApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  tagTypes: ['StripeConnectStatus'],
  endpoints: (builder) => ({
    getStripeConnectStatus: builder.query<StripeConnectAccountStatus, number>({
      queryFn: async (affiliateUid) => {
        try {
          const data = await getStripeConnectStatus(affiliateUid);
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: ['StripeConnectStatus'],
    }),

    getStripeConnectPayouts: builder.query<StripeAchPayout[], number>({
      queryFn: async (affiliateUid) => {
        try {
          const data = await getStripeConnectPayouts(affiliateUid);
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),

    startBankOnboarding: builder.mutation<StripeConnectOnboardingLink, StartBankOnboardingPayload>({
      queryFn: async (payload) => {
        try {
          const data = await startBankOnboarding(payload);
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: ['StripeConnectStatus'],
    }),

    refreshOnboardingLink: builder.mutation<StripeConnectOnboardingLink, RefreshOnboardingLinkPayload>({
      queryFn: async (payload) => {
        try {
          const data = await refreshOnboardingLink(payload);
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
  }),
});

export default stripeConnectApi;

export const {
  useGetStripeConnectStatusQuery,
  useGetStripeConnectPayoutsQuery,
  useStartBankOnboardingMutation,
  useRefreshOnboardingLinkMutation,
} = stripeConnectApi;
